/**
 * Lesson progress percentage — clamped 0..1, used by the in-lab
 * panel's progress bar (session 342C). Pure helper so the math is
 * unit-tested without touching the renderer.
 *
 * Conventions:
 *   - `done === true` returns 1 (full bar) regardless of index.
 *   - `total <= 0` returns 0 (no steps means no progress to show).
 *   - `currentStepIndex` is the 0-based index of the step the student
 *     is currently working on. Progress reflects «steps completed»,
 *     so a student on step 0 sees 0; on step 1 sees 1/total; etc.
 *     This matches the «N of K» badge already in the panel.
 */
export function computeProgressPercent(currentStepIndex, total, done) {
    if (done)
        return 1;
    if (total <= 0)
        return 0;
    const idx = Math.max(0, Math.min(currentStepIndex, total));
    return idx / total;
}
/** Convert raw JSON to runtime `SceneInstance[]`. The fields are
 *  one-to-one with `SceneInstance`; this mostly exists to type-narrow
 *  optional flags and to keep one clear seam for future
 *  back-compatible extensions (e.g. spawn-time decorators). */
export function loadScenario(json) {
    const instances = json.instances.map((inst) => ({
        id: inst.id,
        part: inst.part,
        position: inst.position,
        ...(inst.pinned !== undefined && { pinned: inst.pinned }),
        ...(inst.benchPosition !== undefined && { benchPosition: inst.benchPosition }),
        ...(inst.grabMode !== undefined && { grabMode: inst.grabMode }),
        ...(inst.labelColor !== undefined && { labelColor: inst.labelColor }),
        ...(inst.labelText !== undefined && { labelText: inst.labelText }),
        ...(inst.useBenchSlot !== undefined && { useBenchSlot: inst.useBenchSlot }),
        ...(inst.freeRelease !== undefined && { freeRelease: inst.freeRelease }),
        ...(inst.duplicable !== undefined && { duplicable: inst.duplicable }),
        ...(inst.initialMixture !== undefined && { initialMixture: inst.initialMixture })
    }));
    return {
        id: json.id,
        title: json.title,
        summary: json.summary,
        instances,
        steps: json.steps,
        ...(json.completion !== undefined && { completion: json.completion }),
        ...(json.level !== undefined && { level: json.level }),
        ...(json.autoPin !== undefined && { autoPin: json.autoPin })
    };
}
